import OneSignal from 'react-onesignal';

import { ONESIGNAL_NOTIFICATIONS_LOCAL_KEY } from 'constants/notificationPermissions';

export const resetOneSignalPrompt = function () {
	localStorage.removeItem(ONESIGNAL_NOTIFICATIONS_LOCAL_KEY);
	OneSignal.showSlidedownPrompt();
};
